export const GITHUB_RELEASES_API = 'https://api.github.com/repos/asksaysodev/sayso-desktop-app/releases/latest';
export const LAUNCH_COACH_URL = 'sayso://launch-coach';
export const HELP_CENTER_URL = 'https://asksayso.notion.site/helpcenter';
export const PRIVACY_POLICY_URL = 'https://www.asksayso.com/privacy';
export const TERMS_URL = 'https://www.asksayso.com/terms';
